import React, { useCallback, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import FinancialInstitutionsModal from '@/modules/financials/components/FinancialInstitutionsModal';

const FinancialSectionEditButton = ({ institutions, refreshTask }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const openModal = useCallback(() => {
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <Button
        color="success"
        variant="outlined"
        size="medium"
        startIcon={<EditIcon />}
        onClick={openModal}
      >
        {t('Edit financial institutions')}
      </Button>
      <FinancialInstitutionsModal
        open={open}
        onClose={closeModal}
        refreshTask={refreshTask}
        institutions={institutions}
      />
    </>
  );
};

export default FinancialSectionEditButton;
